// Page-width caps live here so screens/components never hardcode them.
//
// The app targets web too, where an uncapped column would stretch to the full
// window width. Content is capped at ~800px and centered; the scroll *surface*
// stays full-width (so the side gutters still scroll) by applying `BOUNDED` to a
// `ScrollView`'s content container, not the scroll view itself. No-op on phones
// (always narrower than the cap).
//
// Consume via `<BoundedScrollView>` (scrolling content) or `<Bounded>` (static
// bars/columns/popovers) rather than spreading `BOUNDED` across screens.

/** Keep the `max-w` here in sync with any numeric width below. */
export const BOUNDED = 'w-full max-w-[800px] self-center';

/** Floating dialog/sheet cap — narrower than page content. */
export const SHEET_MAX_WIDTH = 560;
